import { oceanSearchGuideLinks } from "../../data/seoContentClusters.mjs";
import s from "./OceanGuideSearchLinks.module.scss";

export default function OceanGuideSearchLinks({ compact = false }) {
  return (
    <section className={`${s.section} ${compact ? s.compact : ""}`} aria-labelledby="ocean-search-guide-title">
      <div className={s.inner}>
        <p className={s.label}>MIYAKO OCEAN GUIDE</p>
        <h2 id="ocean-search-guide-title">宮古島の今日の海況・波・風向きを確認</h2>
        <p className={s.lead}>
          宮古島で今日行く海やシュノーケル場所を選ぶ前に、今日・明日の海況、波予報、風向き、台風の影響を確認できます。
        </p>
        <nav className={s.links} aria-label="宮古島の海況ガイド">
          {oceanSearchGuideLinks.map(([href, label]) => (
            <a href={href} key={href}>{label}<span aria-hidden="true">→</span></a>
          ))}
        </nav>
      </div>
    </section>
  );
}
